import { createHoverEvent } from './hover'
import { createIntersectionEvent } from './intersection'
import { createCustomEvent } from './custom'

export const EVENTS = new Map([
	['custom', createCustomEvent],
	['hover', createHoverEvent],
	['intersection', createIntersectionEvent],
])
